const data = [
	{
		FDP: `Conducted session for the PhD scholars of SKNCOE research center on the topic 
		“How to handle the reviewer comments?”`,
	},
	{
		FDP: `Conducted one day session in a faculty development program at SPPU level on “
		Discrete Mathematics” organized by JSPM Narhe Technical College, July 2020`,
	},
	{
		FDP: `Conducted one day faculty development program at SPPU level on “Discrete 
		Mathematics” at Keystone college, Pune.`,
	},
	{
		FDP: `Conducted many guest lectures on the subjects like Discrete Structure, Computer
		Graphics etc. at different colleges in SPPU.
		`,
	},
	{
		FDP: `Conducted/Coordinated one week “Train the Trainer” Program For the subject 
		Discrete Mathematics at SKNCOE, Pune (2014).`,
	},
	{
		FDP: `Conducted/Coordinated one week “Train the Trainer” Program For the subject Data 
		Base Management System at SKNCOE, Pune (2013)`,
	},
	{
		FDP: `Conducted/Coordinated one week “Train the Trainer” Program For the subject 
		Finance Management and Information System at RMDSCOE, Pune (2013).`,
	},
];

export default data;
